import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getAllTargetData = (id) => {
  const url = `${API_ROOT}/proposal/${id}/target`
  return doGet(url)
}

export const updateTargetGroup = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/target/group`
  return doPost(url, request)
}

export const updateTargetIssues = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/target/issue`
  return doPost(url, request)
}

export const updateTargetSetting = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/target/setting`
  return doPost(url, request)
}

export const getTargetArea = (id) => {
  const url = `${API_ROOT}/proposal/${id}target/area`
  return doGet(url, request)
}

export const saveTargetArea = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/target/area`
  return doPost(url, request)
}

// -------------------------------- subproject

export const getSubProjectAllTargetData = (id) => {
  // /api/subproject/{projectVersionId}/target
  const url = `${API_ROOT}/subproject/${id}/target`
  return doGet(url)
}

export const updateSubProjectTargetGroup = (id, request) => {
  // /api/subproject/{projectVersionId}/target/group
  const url = `${API_ROOT}/subproject/${id}/target/group`
  return doPost(url, request)
}

export const updateSubProjectTargetIssues = (id, request) => {
  // /api/subproject/{projectVersionId}/target/issue
  const url = `${API_ROOT}/subproject/${id}/target/issue`
  return doPost(url, request)
}

export const updateSubProjectTargetSetting = (id, request) => {
  // /api/subproject/{projectVersionId}/target/setting
  const url = `${API_ROOT}/subproject/${id}/target/setting`
  return doPost(url, request)
}

export const saveSubProjectTargetArea = (id, request) => {
  // /api/subproject/{projectVersionId}/target/area
  const url = `${API_ROOT}/subproject/${id}/target/area`
  return doPost(url, request)
}

// --------------------------------
